export enum FieldType {
  TextField = "textfield",
  TextArea = "textarea",
  PhoneField = "phonefield",
}
